import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const MarketingHubLogo = ({
  size,
  style,
  className
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px",
    width: size,
    height: size,
    style: style,
    className: className,
    children: [/*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_1_",
        x1: "254.8093",
        x2: "247.70389",
        y1: "933.97327",
        y2: "945.15558",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "22.824%",
          stopColor: "#FFAC78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "23.571%",
          stopColor: "#FFAB78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "73.378%",
          stopColor: "#FF8861"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#FF7A59"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M253.43118,929.13873c0.31686,0,0.6371,0.04846,0.95036,0.14886 c1.28906,0.41327,2.16362,1.61194,2.16362,2.9657v8.8847c0,1.71997-1.39427,3.11432-3.11432,3.11432h-6.34871 c-1.16664,0-2.23549-0.6521-2.7693-1.68951c-0.53369-1.03741-0.4429-2.28619,0.23543-3.23547l6.34871-8.88464 C251.49274,929.60889,252.44467,929.13873,253.43118,929.13873z",
        fill: "url(#SVGID_1_)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M253.43085,938.02368h6.34882c1.16675,0,2.2355,0.6521,2.76932,1.68951 c0.53369,1.03748,0.4429,2.28625-0.23544,3.23547l-6.34882,8.88464c-0.78714,1.1015-2.19606,1.56799-3.48457,1.15503 c-1.28906-0.41327-2.16362-1.61194-2.16362-2.96564v-8.8847C250.31653,939.41803,251.71082,938.02368,253.43085,938.02368z",
        fill: "#FF7A59"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "253.43427",
        cy: "932.25067",
        fill: "#FF7A59",
        r: "3.11354"
      }), /*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_00000164484440820458717800000008047394472720490883_",
        x1: "241.71416",
        x2: "259.56665",
        y1: "941.138",
        y2: "941.138",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#FFAC78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "81.601%",
          stopColor: "#FF7A59"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M247.08214,938.02368h12.69753 c1.72006,0,3.11432,1.39435,3.11432,3.11432s-1.39426,3.11432-3.11432,3.11432h-12.69753 c-1.72005,0-3.11432-1.39435-3.11432-3.11432S245.36209,938.02368,247.08214,938.02368z",
        fill: "url(#SVGID_00000164484440820458717800000008047394472720490883_)"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_00000055685858886984581310000009947403789386904220_",
        x1: "13.37839",
        x2: "6.27298",
        y1: "4.83617",
        y2: "16.01845",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "22.824%",
          stopColor: "#FFAC78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "23.571%",
          stopColor: "#FFAB78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "73.378%",
          stopColor: "#FF8861"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "100%",
          stopColor: "#FF7A59"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.00028,0.00161 c0.31686,0,0.6371,0.04844,0.95036,0.14886c1.28907,0.41328,2.16362,1.61196,2.16362,2.96569v8.88473 c0,1.71998-1.39428,3.11432-3.11432,3.11432H5.65123c-1.16663,0-2.23549-0.65208-2.7693-1.68951 c-0.5337-1.03743-0.44291-2.28618,0.23542-3.23547l6.34871-8.88467C10.06183,0.47178,11.01377,0.00161,12.00028,0.00161z",
        fill: "url(#SVGID_00000055685858886984581310000009947403789386904220_)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.99994,8.88657h6.34883c1.16674,0,2.23549,0.65208,2.7693,1.68951 c0.5337,1.03749,0.44291,2.28623-0.23542,3.23547l-6.34883,8.88467c-0.78714,1.10147-2.19606,1.56797-3.48457,1.15503 c-1.28907-0.41328-2.16362-1.61196-2.16362-2.96569v-8.88467C8.88562,10.2809,10.2799,8.88657,11.99994,8.88657z",
        fill: "#FF7A59"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "12.00336",
        cy: "3.11354",
        fill: "#FF7A59",
        r: "3.11354"
      }), /*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_00000129896634017324984700000004437046019559677081_",
        x1: "0.28326",
        x2: "18.13576",
        y1: "12.00089",
        y2: "12.00089",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#FFAC78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "81.601%",
          stopColor: "#FF7A59"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.65123,8.88657h12.69754 c1.72004,0,3.11432,1.39434,3.11432,3.11432s-1.39428,3.11432-3.11432,3.11432H5.65123c-1.72004,0-3.11432-1.39434-3.11432-3.11432 S3.93119,8.88657,5.65123,8.88657z",
        fill: "url(#SVGID_00000129896634017324984700000004437046019559677081_)"
      })]
    })]
  });
};

export default MarketingHubLogo;